import {ListItemButton, ListItemButtonProps} from '@mui/material';
import {useCallback} from 'react';
import {NavigateOptions, To, useNavigate} from 'react-router';
import {ComponentWithRequiredChildren, PropsWithRequiredChildren} from '../react/types';

type AllowedButtonProps = Omit<ListItemButtonProps, 'onClick'>;
interface LiteItemRouteButtonProps extends PropsWithRequiredChildren<AllowedButtonProps>, NavigateOptions {
  afterNavigation?: () => void | Promise<void>;
  to: To;
}

export const ListItemRouteButton: ComponentWithRequiredChildren<LiteItemRouteButtonProps> = ({
  afterNavigation,
  children,
  replace,
  state,
  to,
  ...muiProps
}: LiteItemRouteButtonProps) => {
  const navigate = useNavigate();
  const onClick = useCallback(() => {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    void navigate(to, {replace, state});
    if (afterNavigation) {
      void afterNavigation();
    }
  }, [afterNavigation, navigate, replace, state, to]);
  return (
    <ListItemButton {...muiProps} onClick={onClick}>
      {children}
    </ListItemButton>
  );
};
